// @ts-check


import { MapView, Mappedin, MappedinNode, getVenue } from "@mappedin/mappedin-js";


/**
 * @typedef {import("../../../actions/LiveMap/liveMapPageTypes").MapSearchResultsState} MapSearchResultsState
 * @typedef {import("@mappedin/mappedin-js/renderer/internal").SmartTooltip} SmartTooltip
 * 
 */



export class MapSearchResultsLogic {

  /**
   * @param {any | undefined} sData
   * @param {Mappedin} venue
   * @param {MapView} mapView
   * @param {any | undefined} currentEntrance
   * @param {(mapView: MapView) => void} recolorMap
   */
  static process = (sData, venue, mapView, currentEntrance, recolorMap) => {

    
    let sSearchResults = sData.get('searchResults');

    /** @type {MapSearchResultsState} */
    let sSearchResultsState = sData.get('searchResultsState');



    if (sSearchResultsState === "HIDDEN") {
      // console.log('xxxxxxxxxxxxx ------- SEARCH ------- => HIDE !!!!!');
      // mapView.removeAllTooltips();
      // recolorMap(venue, mapView);
      return;
    }


    // /** @type {MappedinNode | null} */
    // let entrance = currentEntrance.current;
    // if (!entrance) {
    //   return;
    // }


    // let parentPolygon = entrance.polygon;


    // // Highlight current polygon
    // recolorMap(venue, mapView);
    // mapView.setPolygonColor(parentPolygon, "#0000FF");


    // mapView.removeAllTooltips();
    

    if (sSearchResultsState === "LOADING") {
      // console.log('xxxxxxxxxxxxx ------- SEARCH ------- => LOADING !!!!!');
      // let tooltipHtml = getLocationTooltipLoadingHtml(sLocationDetails);
      // tooltipObject = mapView.createTooltip(entrance, tooltipHtml);
    }
    
    if (sSearchResultsState === "VISIBLE") {
      // console.log('xxxxxxxxxxxxx ------- SEARCH ------- => SHOW !!!!!', sSearchResults);

      // let tooltipHtml = getLocationTooltipHtml(sLocationDetails);
      // tooltipObject = mapView.createTooltip(entrance, tooltipHtml);
    }
    

  }



}




////////////////////////////////////////
// Helper functions.
//

